<script>
	let { class: className = 'w-36' } = $props();
</script>

<!-- Official Tripadvisor Travellers' Choice badge (served by Tripadvisor's award widget for our listing) -->
<a
	href="https://www.tripadvisor.com.au/Attraction_Review-g255097-d12062092-Reviews-Tassie_Tours_Tasmania-Hobart_Greater_Hobart_Tasmania.html"
	target="_blank"
	rel="noopener noreferrer"
	class="ml-8 flex flex-col items-center {className}"
>
	<enhanced:img
		src="$lib/assets/images/tripadvisor-travellers-choice-2026.png"
		alt="Tripadvisor Travellers' Choice 2026 - 10 years in a row"
		class="w-full"
		loading="lazy"
	/>
	<span class="mt-1 text-center text-sm font-semibold">10 years in a row</span>
</a>
